import { render } from "./VTextEditor.vue?vue&type=template&id=2af6e405"
import script from "./VTextEditor.vue?vue&type=script&lang=js"
export * from "./VTextEditor.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/VTextEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2af6e405"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2af6e405', __exports__)) {
    api.reload('2af6e405', __exports__)
  }
  
  module.hot.accept("./VTextEditor.vue?vue&type=template&id=2af6e405", () => {
    api.rerender('2af6e405', render)
  })

}


export default __exports__